import React, { useEffect, useRef, useState } from 'react'
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import './leaderboard-landing-page.styles.scss';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import LeaderboardList from './leaderboard-list.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import CreateLeaderboard from './create-leaderboard.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';


const LeaderboardsLandingPage = ({
  gameData,
  gameElements,
  playerList,
  role
}) => {

  const [leaderboardsFromDb, setLeaderboardsFromDb] = useState(null);
  const leaderboardsRef = useRef();
  const leaderboardsListenerRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  
  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
    if (!gameData?.gameName) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'Manage Leaderboards';
    }
    changeDocumentTitle(`Leaderboards | Manage ${gameData?.gameName}`);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!gameId) return;
    getGameElementsToManage();
    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const leaderboardObj = {};
        Object.values(completeGameElementData)
          .filter(e => e.type === 'leaderboard' && e.status === 'active')
          .forEach(e => {
            leaderboardObj[e.id] = e;
          });
        setLeaderboardsFromDb(leaderboardObj);
        return;
      }
      getCollectionFromDb({
        "collection": `games/${gameId}/gameElements`,
        "query1": {
          "key": "type",
          "condition": "==",
          "value": "leaderboard"
        },
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        leaderboardsRef.current = {
          ...leaderboardsRef.current,
          ...{ [data.id]: data }
        }
        setLeaderboardsFromDb(leaderboardsRef.current);
      }
      function handleListener(data) {
        leaderboardsListenerRef.current = data;
      }
    }
    return () => {
      if (leaderboardsListenerRef.current) {
        leaderboardsListenerRef.current();
        leaderboardsListenerRef.current = null;
      }
    }
  }, [gameId, isPreview, completeGameElementData])

  function cancel() {
    // if (location.pathname.endsWith('/leaderboards')) {
    //     navigate(`/manage/${gameData.path}`)
    // } else {
    navigate(-1);
    // }
  }



  return (
    <div className='manage-leaderboards-container'>

      <Routes>
        <Route path='' element={
          <div className='manage-leaderboards-content g-card'>
            <BackButton cancel={cancel} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/leaderboard.png' className='head-icon' />
              Create and Edit Leaderboards</div>
            <hr />
            <LeaderboardList
              gameElements={gameElements}
              leaderboardsFromDb={leaderboardsFromDb}
              gameData={gameData}
              role={role} />
          </div>
        }></Route>
        <Route path='create' element={
          <CreateLeaderboard
            gameData={gameData}
            gameElements={gameElements}
            leaderboardsFromDb={leaderboardsFromDb}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path='edit/:leaderboardId' element={
          <CreateLeaderboard
            gameData={gameData}
            gameElements={gameElements}
            leaderboardsFromDb={leaderboardsFromDb}
            playerList={playerList}
            role={role} />
        }></Route>
      </Routes>
    </div >
  )
}

export default LeaderboardsLandingPage